export class CustomIdTags {
    public static readonly CUSTOM_ID_TAGS = [
        {
            tagName: 'img',
            alias: 'image'
        },
        {
            tagName: 'input',
            alias: 'field'
        },
        {
            tagName: 'span',
            alias: 'lbl'
        },
        {
            tagName: 'mat-label',
            alias: 'lbl'
        },
        {
            tagName: 'button',
            alias: 'btn'
        },
        {
            tagName: 'mat-form-field',
            alias: 'field'
        },
        {
            tagName: 'tr',
            alias: 'tr'
        },
        {
            tagName: 'mat-option',
            alias: 'option'
        },
        {
            tagName: 'h1',
            alias: 'lbl'
        },
        {
            tagName: 'h2',
            alias: 'lbl'
        },
        {
            tagName: 'h3',
            alias: 'lbl'
        },
        {
            tagName: 'table',
            alias: 'list'
        },
        {
            tagName: 'th',
            alias: 'list_header'
        },
        {
            tagName: 'td',
            alias: 'list_cell'
        },
        {
            tagName: 'div',
            alias: 'view'
        },
        {
            tagName: 'mat-icon',
            alias: 'icon'
        },
        {
            tagName: 'mat-error',
            alias: 'err'
        },
        {
            tagName: 'mat-datepicker-toggle',
            alias: 'btn'
        },
        {
            tagName: 'mat-datepicker',
            alias: 'field'
        },
        {
            tagName: 'p',
            alias: 'lbl'
        },
        {
            tagName: 'mat-select',
            alias: 'select'
        },
        {
            tagName: 'mat-checkbox',
            alias: 'checkbox'
        },
        {
            tagName: 'split-area',
            alias: 'split_area'
        },
        {
            tagName: 'mat-date-range-input',
            alias: 'date_range_input'
        },
        {
            tagName: 'mat-hint',
            alias: 'mat_hint'
        },
        {
            tagName: 'mat-expansion-panel',
            alias: 'expansion_panel'
        },
        {
            tagName: 'ngx-mat-datetime-picker',
            alias: 'datetime_picker'
        },
        {
            tagName: 'cdk-virtual-scroll-viewport',
            alias: 'virtual_scroll'
        },
        {
            tagName: 'mat-autocomplete',
            alias: 'autocomplete'
        },

        
    ];
}